import { Component, computed, OnInit, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { finalize, map } from 'rxjs';
import { AccountApi } from 'src/app/shared/apis/account.api';
import { LoadingModule } from 'src/app/shared/directive/loading/loading.module';
import { Web3WalletType } from 'src/app/shared/interfaces/auth.interface';
import { LocalStorageService } from 'src/app/shared/service/localstorage.service';
import { WalletDialogType, WalletService } from './../wallet.service';

@Component({
  standalone: true,
  selector: 'first-deposit',
  templateUrl: './first-deposit.component.html',
  styleUrls: ['./first-deposit.component.scss'],
  imports: [LoadingModule],
})
export class FirstDepositComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private accountApi: AccountApi,
    protected walletService: WalletService,
    protected localStorageService: LocalStorageService,
  ) {}

  /** 是否為 Telegram App */
  private isTgApp = sessionStorage.getItem('isTgApp') === 'true';

  /** 已綁定的 Web3 錢包 */
  private boundWallet = signal<Web3WalletType | null>(null);

  /** Web3 圖片 Dict */
  private walletImgDict: Partial<{ [key in Web3WalletType]: string }> = {
    [Web3WalletType.WalletConnect]: 'assets/images/login-wallets/walletconnect.svg',
    [Web3WalletType.CoinbaseWallet]: 'assets/images/login-wallets/coinbasewallet.svg',
    [Web3WalletType.TonConnect]: 'assets/images/login-wallets/tonconnect.svg',
  };

  /** 是否已加載結束 */
  protected isLoaded = signal(false);

  protected walletTag = computed<string>(() => {
    return this.boundWallet() ? 'Connected' : 'Fastest';
  });
  protected walletTitle = computed<string>(() => {
    return this.boundWallet() ? 'Web3 transfer' : 'Connect your wallet';
  });
  protected walletDesc = computed<string>(() => {
    return this.boundWallet() ? 'Deposit using your connected wallet' : 'Wallet Connect, Base or TON';
  });

  protected walletImg = computed<string>(() => {
    // Only show TonConnect when using TG Mini App
    if (this.isTgApp) {
      return this.walletImgDict[Web3WalletType.TonConnect]!;
    }

    // Show bound web3 wallet when first time deposit
    return this.walletImgDict[this.boundWallet()!] || 'assets/images/first-deposit/first_deposit.png';
  });

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const tab = params['tab'];
      const subTab = params['subTab'];

      // 檢查tab/sub是否合法
      if (this.walletService.isValidTabPair(tab, subTab)) {
        this.walletService.walletDialogType$.next(WalletDialogType.DEPOSIT_WITHDRAW);
      }
    });

    this._fetchBoundWeb3Wallet();
  }

  private _fetchBoundWeb3Wallet(): void {
    this.isLoaded.set(false);
    this.accountApi
      .getWeb3Wallet()
      .pipe(
        map(res => res.data[0]?.web3WalletType),
        finalize(() => this.isLoaded.set(true)),
      )
      .subscribe(type => this.boundWallet.set(type || null));
  }
}
